import { Component, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-laterreta-splashscreen',
  templateUrl: './laterreta-splashscreen.component.html',
  styleUrls: ['./laterreta-splashscreen.component.scss']
})
export class LaterretaSplashscreenComponent implements OnInit {

  constructor() { }
  client = environment.client;

  ngOnInit(): void {
  }

}
